import EBModalLayout from "../../layouts/modal";
import { guessTimezone } from "@eventbuilder-utils/datetime";

import { EBSession } from "../../utils/session";
import { AndFilter, EndsWithFilter, EqualityFilter, GreaterThanEqualsFilter, InListFilter, LessThanEqualsFilter, NotFilter, OrFilter, parseFilter, StartsWithFilter, SubstringFilter } from "@eventbuilder-utils/filter";
import { showErrorToast } from "../../utils/toast";
import DateTimeTimezonePickerModal from "../datetimetimezonepicker-modal";

import "./style.scss";

export default class FilterModal extends EBModalLayout {
    #baseFilter;
    #fields = [];
    #timeDifference = 0//getTimeDifference();
    #filterElement = this.contentElement;

    static open(filter, fields) {
        return new FilterModal({ filter: filter, fields: fields }).open()
    }

    constructor(opts) {
        super({}, {
            className: "modal--lg",
            title: "Filter",
            static: true
        });

        if(opts.filterName){
            this.addControl("Save As Default", { className: "primary", icon: "save" }).addEventListener("click", async (ev) => {
                EBSession.account.customTableFilters[opts.filterName] = this.buildFilter(this.#filterElement.children[0]);
                await EBSession.patch(`/api/v3/me`, { data: { customTableFilters: { value: JSON.stringify(EBSession.account.customTableFilters)} } }).then(() => {
                }).catch(ex => { console.error(ex); showErrorToast(ex.message || ex); });
                this.close(this.buildFilter(this.#filterElement.children[0]));
            })
            if(opts.defaultValue){
                this.addControl("Reset To Default", { className: "primary", icon: "save" }).addEventListener("click", async (ev) => {;
                    EBSession.account.customTableFilters[opts.filterName] = "";
                    await EBSession.patch(`/api/v3/me`, { data: { customTableFilters: { value: JSON.stringify(EBSession.account.customTableFilters)} } }).then(() => {
                    }).catch(ex => { console.error(ex); showErrorToast(ex.message || ex); });
                    this.close(opts.defaultValue);
                })
            }
            this.lzGetElement(`& > div.dialog > div.controls > button:last-of-type`)?.insertAdjacentHTML("afterend", `<div style="flex-grow:1;"></div>`);
        }

        this.addControl("Save", { className: "primary" }).addEventListener("click", (ev) => {
            this.close(this.buildFilter(this.#filterElement.children[0]));
        })

        this.addControl("Close").addEventListener("click", (ev) => {
            this.close(undefined);
        })

        if (typeof opts.fields == "function")
            this.#fields = opts.fields();
        else
            this.#fields = opts.fields || [];
        for (let field of this.#fields) {
            if (!!!field.operators) field.operators = ["=","!=",">=","!>=","<=","!<=","=*","!=*"];
        }

        if(opts.baseFilter){
            this.#baseFilter = parseFilter(opts.baseFilter);
            this.buildView(this.#baseFilter, this.contentElement, false);
            this.#filterElement = this.contentElement.querySelector(`.base-filter > eb-filter-list > .edit-filter`);
        }

        try {
            let result = parseFilter(opts.filter || `(&(${this.#fields[0]?.name || ""}=))`);
            this.buildView(result, this.#filterElement);
        } catch (ex) {
            console.error(ex);
            showErrorToast("Unknown error parsing filter");
        }
    }

    /*show() {
        return new Promise((resolve, reject) => {
            this.on("eb:modal.close.click", (event) => { resolve(undefined); this.close(); });
            this.on("eb:modal.control.save.click", (event) => { resolve(this.buildFilter(this.content.children[0])); this.close(); });
            super.show();
        });
    }*/  

    handleFilterFieldChange(event) {
        let attrEl = event.target.parentElement.children[0];
        let compEl = event.target.parentElement.children[1];
        let field = this.#fields.find(a => a.name == attrEl.value);
        if(!!!field.type) field.type = "string"
        if(field.type){
            if(field.type === "number"){
                let valueNumberElement = document.createElement("input");
                valueNumberElement.type = "number";
                event.target.parentElement.children[2].replaceWith(valueNumberElement);
            } else if(field.type === "datetime"){
                if(["=*", "!=*"].includes(compEl.value)){
                    let div = document.createElement("div");
                    div.setAttribute("style", "grid-template-columns: 1fr 1fr; display: grid;");
                    let valueDatetimeElement = div.appendChild(createDateTimeEl());
                    let valueDatetimeElement2 = div.appendChild(createDateTimeEl());
                    valueDatetimeElement.children[0].value = `${new Intl.DateTimeFormat(window.navigator.language, { dateStyle: "short", timeStyle: "short", timeZone: guessTimezone()}).format(Date.now())}`
                    valueDatetimeElement2.children[0].value = `${new Intl.DateTimeFormat(window.navigator.language, { dateStyle: "short", timeStyle: "short", timeZone: guessTimezone()}).format(Date.now())}`
                    event.target.parentElement.children[2].replaceWith(div);
                }
                else if(["=", "!="].includes(compEl.value)){
                    let valueDatetimeElement = createDateTimeEl({time: false, timezone: false});
                    valueDatetimeElement.children[0].value = `${new Intl.DateTimeFormat(window.navigator.language, { dateStyle: "short" }).format(getDateTimestamp(Date.now()))}`
                    event.target.parentElement.children[2].replaceWith(valueDatetimeElement);
                } else {
                    let valueDatetimeElement = createDateTimeEl();
                    valueDatetimeElement.children[0].value = `${new Intl.DateTimeFormat(window.navigator.language, { dateStyle: "short", timeStyle: "short", timeZone: guessTimezone()}).format(getDateTimestamp(Date.now()))}`
                    event.target.parentElement.children[2].replaceWith(valueDatetimeElement);
                }
                
            } else {
                if ((field?.options?.length || 0) > 0) {
                    let valueDropdownElement = document.createElement("select");
                    for (let option of [ { displayText: "(Blank)", value: "" }, ...field.options ]) {
                        let valueOptionElement = valueDropdownElement.appendChild(document.createElement("option"));
                        valueOptionElement.value = option.value;
                        valueOptionElement.innerText = option.displayText || option.name || option.value;
                    }
                    event.target.parentElement.children[2].replaceWith(valueDropdownElement);
                } else {
                    let valueElement = document.createElement("input");
                    valueElement.value = event.target.parentElement.children[2]?.value || "";
                    event.target.parentElement.children[2].replaceWith(valueElement);
                }
            }
        }

        for (let el of compEl.children) {
            if (field?.operators.includes(el.value)) {
                el.disabled = false;
                el.style.removeProperty("display");
            } else {
                el.disabled = true;
                el.style.setProperty("display","none");
            }
        }
        if (compEl.querySelector(`option[value="${compEl.value}"]`).disabled == true) {
            compEl.value = compEl.querySelector(`option:not([disabled])`).value;
        }
        /*
        if ((field?.options?.length || 0) == 0) {
            event.target.parentElement.children[2].replaceWith(document.createElement("input"));
        } else {
            let valueDropdownElement = document.createElement("select");
            valueDropdownElement.insertAdjacentHTML("afterbegin", `<option value="">(Blank)</option>`);
            for (let option of field.options) {
                let valueOptionElement = valueDropdownElement.appendChild(document.createElement("option"));
                valueOptionElement.value = option.value;
                valueOptionElement.innerText = option.displayText || option.name || option.value;
            }
            event.target.parentElement.children[2].replaceWith(valueDropdownElement);
        }
            */
    }

    handleFilterItemFieldChange(event) {
        let attrEl = event.target.parentElement.children[0];
        let compEl = event.target.parentElement.children[1];
        let field = this.#fields.find(a => a.name == attrEl.value);
        if(!!!field.type) field.type = "string"
        if(field.type){
            if(field.type === "number"){
                let valueNumberElement = document.createElement("input");
                valueNumberElement.type = "number";
                event.target.parentElement.children[2].replaceWith(valueNumberElement);
            } else if(field.type === "datetime"){
                if(["=*", "!=*"].includes(compEl.value)){
                    let div = document.createElement("div");
                    div.setAttribute("style", "grid-template-columns: 1fr 1fr; display: grid;");
                    let valueDatetimeElement = div.appendChild(createDateTimeEl());
                    let valueDatetimeElement2 = div.appendChild(createDateTimeEl());
                    valueDatetimeElement.children[0].value = `${new Intl.DateTimeFormat(window.navigator.language, { dateStyle: "short", timeStyle: "short", timeZone: guessTimezone()}).format(Date.now())}`
                    valueDatetimeElement2.children[0].value = `${new Intl.DateTimeFormat(window.navigator.language, { dateStyle: "short", timeStyle: "short", timeZone: guessTimezone()}).format(Date.now())}`
                    event.target.parentElement.children[2].replaceWith(div);
                }
                else if(["=", "!="].includes(compEl.value)){
                    let valueDatetimeElement = createDateTimeEl({time: false, timezone: false});
                    valueDatetimeElement.children[0].value = `${new Intl.DateTimeFormat(window.navigator.language, { dateStyle: "short" }).format(getDateTimestamp(Date.now()))}`
                    event.target.parentElement.children[2].replaceWith(valueDatetimeElement);
                } else {
                    let valueDatetimeElement = createDateTimeEl();
                    valueDatetimeElement.children[0].value = `${new Intl.DateTimeFormat(window.navigator.language, { dateStyle: "short", timeStyle: "short", timeZone: guessTimezone()}).format(getDateTimestamp(Date.now()))}`
                    event.target.parentElement.children[2].replaceWith(valueDatetimeElement);
                }
                
            } else {
                if ((field?.options?.length || 0) > 0) {
                    let valueDropdownElement = document.createElement("select");
                    for (let option of [ { displayText: "(Blank)", value: "" }, ...field.options ]) {
                        let valueOptionElement = valueDropdownElement.appendChild(document.createElement("option"));
                        valueOptionElement.value = option.value;
                        valueOptionElement.innerText = option.displayText || option.name || option.value;
                    }
                    event.target.parentElement.children[2].replaceWith(valueDropdownElement);
                } else {
                    let valueElement = document.createElement("input");
                    valueElement.value = event.target.parentElement.children[2]?.value || "";
                    event.target.parentElement.children[2].replaceWith(valueElement);
                }
            }
        }

        for (let el of compEl.children) {
            if (field?.operators.includes(el.value)) {
                el.disabled = false;
                el.style.removeProperty("display");
            } else {
                el.disabled = true;
                el.style.setProperty("display","none");
            }
        }
        if (compEl.querySelector(`option[value="${compEl.value}"]`).disabled == true) {
            compEl.value = compEl.querySelector(`option:not([disabled])`).value;
        }
        /*
        if ((field?.options?.length || 0) == 0) {
            event.target.parentElement.children[2].replaceWith(document.createElement("input"));
        } else {
            let valueDropdownElement = document.createElement("select");
            valueDropdownElement.insertAdjacentHTML("afterbegin", `<option value="">(Blank)</option>`);
            for (let option of field.options) {
                let valueOptionElement = valueDropdownElement.appendChild(document.createElement("option"));
                valueOptionElement.value = option.value;
                valueOptionElement.innerText = option.displayText || option.name || option.value;
            }
            event.target.parentElement.children[2].replaceWith(valueDropdownElement);
        }
            */
    }

    handleFilterItemOperatorChange(event) {
        let attrEl = event.target.parentElement.children[0];
        let compEl = event.target.parentElement.children[1];
        let field = this.#fields.find(a => a.name == attrEl.value);
        if(!!!field.type) field.type = "string"
        if(field.type){
            if(field.type === "number"){
                let valueNumberElement = document.createElement("input");
                valueNumberElement.type = "number";
                event.target.parentElement.children[2].replaceWith(valueNumberElement);
            } else if(field.type === "datetime"){
                if(["=*", "!=*"].includes(compEl.value)){
                    let div = document.createElement("div");
                    div.setAttribute("style", "grid-template-columns: 1fr 1fr; display: grid;");
                    let valueDatetimeElement = div.appendChild(createDateTimeEl());
                    let valueDatetimeElement2 = div.appendChild(createDateTimeEl());
                    valueDatetimeElement.children[0].value = `${new Intl.DateTimeFormat(window.navigator.language, { dateStyle: "short", timeStyle: "short", timeZone: guessTimezone()}).format(Date.now())}`
                    valueDatetimeElement2.children[0].value = `${new Intl.DateTimeFormat(window.navigator.language, { dateStyle: "short", timeStyle: "short", timeZone: guessTimezone()}).format(Date.now())}`
                    event.target.parentElement.children[2].replaceWith(div);
                }
                else if(["=", "!="].includes(compEl.value)){
                    let valueDatetimeElement = createDateTimeEl({time: false, timezone: false});
                    valueDatetimeElement.children[0].value = `${new Intl.DateTimeFormat(window.navigator.language, { dateStyle: "short" }).format(getDateTimestamp(Date.now()))}`
                    event.target.parentElement.children[2].replaceWith(valueDatetimeElement);
                } else {
                    let valueDatetimeElement = createDateTimeEl();
                    valueDatetimeElement.children[0].value = `${new Intl.DateTimeFormat(window.navigator.language, { dateStyle: "short", timeStyle: "short", timeZone: guessTimezone()}).format(getDateTimestamp(Date.now()))}`
                    event.target.parentElement.children[2].replaceWith(valueDatetimeElement);
                }
                
            } else {
                if (["~=", "!~="].includes(compEl.value)){
                    let valueDivElement = document.createElement("div");
                    valueDivElement.setAttribute("data-type", "in-list");
                    const valueEl = valueDivElement.appendChild(document.createElement("input"));
                    valueEl.type = "hidden";
                    valueEl.value = event.target.parentElement.children[2]?.value || "";
                    for(const tag of valueEl.value.split("||").filter(a => a.trim() !== "")){
                        const el = valueDivElement.appendChild(document.createElement("button"));
                        el.setAttribute("data-eb-tag", tag);
                        el.innerHTML = `<span aria-hidden="true">${tag}</span><svg class="toggle" data-src="/assets/images/remove.svg" aria-hidden="true"></svg>`;
                        el.addEventListener("click", (ev) => {
                            valueDivElement.firstChild.value = valueDivElement.firstChild.value.split("||").filter(a => a != tag).join("||");
                            ev.target.remove();
                        });
                    }
                    const inputEl = valueDivElement.appendChild(document.createElement("input"));
                    inputEl.type = "text";
                    inputEl.addEventListener("keydown", event => {
                        if(event.key === "Enter" && event.target.value.trim() !== ""){
                            const tags = event.target.value.trim().split("||").map(a => a.trim());
                            const oldTags = valueDivElement.firstChild.value.split("||");
                            const newTags = tags.filter(tag => !oldTags.includes(tag));
                            valueDivElement.firstChild.value = [...oldTags, ...newTags].filter(a => a.trim() !== "").join("||");
                            for (const tag of newTags) {
                                const el = valueDivElement.insertBefore(document.createElement("button"), inputEl);
                                el.setAttribute("data-eb-tag", tag);
                                el.innerHTML = `<span aria-hidden="true">${tag}</span><svg class="toggle" data-src="/assets/images/remove.svg" aria-hidden="true"></svg>`;
                                el.addEventListener("click", (ev) => {
                                    valueDivElement.firstChild.value = valueDivElement.firstChild.value.split("||").filter(a => a != tag).join("||");
                                    ev.target.remove();
                                });
                            }
                            event.target.value = "";
                        }
                    });
                    //valueElement.value = event.target.parentElement.children[2]?.value || "";
                    event.target.parentElement.children[2].replaceWith(valueDivElement);
                } else {
                    if ((field?.options?.length || 0) > 0) {
                        let valueDropdownElement = document.createElement("select");
                        for (let option of [ { displayText: "(Blank)", value: "" }, ...field.options ]) {
                            let valueOptionElement = valueDropdownElement.appendChild(document.createElement("option"));
                            valueOptionElement.value = option.value;
                            valueOptionElement.innerText = option.displayText || option.name || option.value;
                        }
                        event.target.parentElement.children[2].replaceWith(valueDropdownElement);
                    } else {
                        let valueElement = document.createElement("input");
                        valueElement.value = event.target.parentElement.children[2]?.value || "";
                        event.target.parentElement.children[2].replaceWith(valueElement);
                    }
                }
            }
        }

        for (let el of compEl.children) {
            if (field?.operators.includes(el.value)) {
                el.disabled = false;
                el.style.removeProperty("display");
            } else {
                el.disabled = true;
                el.style.setProperty("display","none");
            }
        }
        if (compEl.querySelector(`option[value="${compEl.value}"]`).disabled == true) {
            compEl.value = compEl.querySelector(`option:not([disabled])`).value;
        }
        /*
        if ((field?.options?.length || 0) == 0) {
            event.target.parentElement.children[2].replaceWith(document.createElement("input"));
        } else {
            let valueDropdownElement = document.createElement("select");
            valueDropdownElement.insertAdjacentHTML("afterbegin", `<option value="">(Blank)</option>`);
            for (let option of field.options) {
                let valueOptionElement = valueDropdownElement.appendChild(document.createElement("option"));
                valueOptionElement.value = option.value;
                valueOptionElement.innerText = option.displayText || option.name || option.value;
            }
            event.target.parentElement.children[2].replaceWith(valueDropdownElement);
        }
            */
    }

    async buildEBFilter(filter, target = this.#filterElement, editable = true){
        let baseEl = target.appendChild(document.createElement("eb-filter"));
        if(!editable) baseEl.classList.add("base-filter");
        let headEl = baseEl.appendChild(document.createElement("eb-filter-head"));
        let typeEl = headEl.appendChild(document.createElement("select"));
        typeEl.disabled = !editable;
        let typeAndOptionEl = typeEl.appendChild(document.createElement("option"));
        typeAndOptionEl.value = "&";
        typeAndOptionEl.innerText = "Match all conditions";
        if (filter instanceof AndFilter)
            typeAndOptionEl.selected = true;
        let typeOrOptionEl = typeEl.appendChild(document.createElement("option"));
        typeOrOptionEl.value = "|";
        typeOrOptionEl.innerText = "Match any condition";
        if (filter instanceof OrFilter)
            typeOrOptionEl.selected = true;
    
        if(editable){
            let removeButtonEl = headEl.appendChild(document.createElement("button"));
            removeButtonEl.innerHTML = `<svg data-src="/assets/images/trash.svg"></svg>`;
            removeButtonEl.ariaLabel = "delete group";
            removeButtonEl.addEventListener("click", event => {
                event.target.parentElement.parentElement.remove();
            });
        }

        let listEl = baseEl.appendChild(document.createElement("eb-filter-list"));
        for (let subfilter of filter.filters)
            this.buildView(subfilter, listEl, editable);

        if(!editable){
            const el = document.createElement("div");
            el.className = "edit-filter";
            listEl.appendChild(el);
        }
        
        let footEl = baseEl.appendChild(document.createElement("eb-filter-foot"));
        if(editable){
            let addSubButtonEl = footEl.appendChild(document.createElement("button"));
            addSubButtonEl.innerHTML = `<svg data-src="/assets/images/folder-plus.svg"></svg>`;
            addSubButtonEl.ariaLabel = "insert sub group";
            addSubButtonEl.addEventListener("click", (event) => {
                this.buildView(new AndFilter([new EqualityFilter(this.#fields[0].name,"")]), event.target.parentElement.parentElement.children[1]);
            });
            let addButtonEl = footEl.appendChild(document.createElement("button"));
            addButtonEl.innerHTML = `<svg data-src="/assets/images/plus.svg"></svg>`;
            addButtonEl.ariaLabel = "insert property";
            addButtonEl.addEventListener("click", (event) => {
                const prevSibling = [...event.target.parentElement.parentElement.children[1].children].filter(child => child.nodeName === "EB-FILTER-LIST-ITEM").pop()
                const newFilter = prevSibling ? this.getNewPropertyFilter(prevSibling) : new EqualityFilter(this.#fields[0].name,"");
                this.buildView(newFilter, event.target.parentElement.parentElement.children[1]);
            });
        }
        if(target === this.contentElement.querySelector(`#edit-filter`)){
            let helpText = target.appendChild(document.createElement("small"));
            helpText.innerHTML = `Filter values are <b>NOT</b> case sensitive`;
        }
    }

    async buildEBFilterItem(filter, target = this.#filterElement, editable = true){
        let baseEl = target.appendChild(document.createElement("eb-filter-list-item"));

        let fieldSelectElement = baseEl.appendChild(document.createElement("select"));
        fieldSelectElement.disabled = !editable;
        for (let field of this.#fields) {
            let fieldOptionElement = fieldSelectElement.appendChild(document.createElement("option"));
            fieldOptionElement.value = field.name;
            fieldOptionElement.innerText = field.displayText || field.name;
            if (filter instanceof NotFilter) {
                if (filter.filters[0].attribute == field.name) {
                    fieldOptionElement.selected = true;
                }
            } else {
                if (filter.attribute == field.name) {
                    fieldOptionElement.selected = true;
                }
            }
            fieldSelectElement.addEventListener("change", event => this.handleFilterFieldChange(event));
        }

        let field = this.#fields.find(a => a.name == (!!filter.filters ? filter.filters[0].attribute : filter.attribute));

        let operatorElement = baseEl.appendChild(document.createElement("select"));
        operatorElement.disabled = !editable;
        let operatorEqualsOptionElement = operatorElement.appendChild(document.createElement("option"));
        operatorEqualsOptionElement.value = "=";
        operatorEqualsOptionElement.innerText = "Equals";
        if (filter instanceof EqualityFilter)
            operatorEqualsOptionElement.selected = true;

        let operatorNotEqualsOptionElement = operatorElement.appendChild(document.createElement("option"));
        operatorNotEqualsOptionElement.value = "!=";
        operatorNotEqualsOptionElement.innerText = "Does not equal";
        if (filter instanceof NotFilter && filter.filters[0] instanceof EqualityFilter)
            operatorNotEqualsOptionElement.selected = true;
        
        let operatorGreaterThanOptionElement = operatorElement.appendChild(document.createElement("option"));
        operatorGreaterThanOptionElement.value = ">=";
        operatorGreaterThanOptionElement.innerText = "Greater than";
        if (filter instanceof GreaterThanEqualsFilter)
            operatorGreaterThanOptionElement.selected = true;

        let operatorNotGreaterThanOptionElement = operatorElement.appendChild(document.createElement("option"));
        operatorNotGreaterThanOptionElement.value = "!>=";
        operatorNotGreaterThanOptionElement.innerText = "Not greater than";
        if (filter instanceof NotFilter && filter.filters[0] instanceof GreaterThanEqualsFilter)
            operatorNotGreaterThanOptionElement.selected = true;

        let operatorLessThanOptionElement = operatorElement.appendChild(document.createElement("option"));
        operatorLessThanOptionElement.value = "<=";
        operatorLessThanOptionElement.innerText = "Less than";
        if (filter instanceof LessThanEqualsFilter)
            operatorLessThanOptionElement.selected = true;

        let operatorNotLessThanOptionElement = operatorElement.appendChild(document.createElement("option"));
        operatorNotLessThanOptionElement.value = "!<=";
        operatorNotLessThanOptionElement.innerText = "Not less than";
        if (filter instanceof NotFilter && filter.filters[0] instanceof LessThanEqualsFilter)
            operatorNotLessThanOptionElement.selected = true;

        let operatorContainsOptionElement = operatorElement.appendChild(document.createElement("option"));
        operatorContainsOptionElement.value = "=*";
        operatorContainsOptionElement.innerText = "Contains";
        if (filter instanceof SubstringFilter) {
            operatorContainsOptionElement.selected = true;
            filter.value = filter.value.replace(/^\*/,"").replace(/\*$/,"");
        }

        let operatorNotContainsOptionElement = operatorElement.appendChild(document.createElement("option"));
        operatorNotContainsOptionElement.value = "!=*";
        operatorNotContainsOptionElement.innerText = "Does not contain";
        if (filter instanceof NotFilter && filter.filters[0] instanceof SubstringFilter) {
            operatorNotContainsOptionElement.selected = true;
            filter.filters[0].value = filter.filters[0].value.replace(/^\*/,"").replace(/\*$/,"");
        }

        let operatorStartsWithOptionElement = operatorElement.appendChild(document.createElement("option"));
        operatorStartsWithOptionElement.value = "^=";
        operatorStartsWithOptionElement.innerText = "Starts With";
        if (filter instanceof StartsWithFilter) {
            operatorStartsWithOptionElement.selected = true;
            filter.value = filter.value.replace(/^\^/,"");
        }

        let operatorEndsWithOptionElement = operatorElement.appendChild(document.createElement("option"));
        operatorEndsWithOptionElement.value = "$=";
        operatorEndsWithOptionElement.innerText = "Ends With";
        if (filter instanceof EndsWithFilter) {
            operatorEndsWithOptionElement.selected = true;
            filter.value = filter.value.replace(/\$$/,"");
        }

        let operatorIncludes = operatorElement.appendChild(document.createElement("option"));
        operatorIncludes.value = "~=";
        operatorIncludes.innerText = "In List";
        if (filter instanceof InListFilter) {
            operatorIncludes.selected = true;
        }

        let operatorNotIncludes = operatorElement.appendChild(document.createElement("option"));
        operatorNotIncludes.value = "!~=";
        operatorNotIncludes.innerText = "Not In List";
        if (filter instanceof NotFilter && filter.filters[0] instanceof InListFilter) {
            operatorNotIncludes.selected = true;
        }

        for (let el of operatorElement.children) {
            if (field?.operators.includes(el.value)) {
                el.disabled = false;
                el.style.removeProperty("display");
            } else {
                el.disabled = true;
                el.style.setProperty("display","none");
            }
        }
        
        operatorElement.addEventListener("change", event => this.handleFilterItemOperatorChange(event)); // this.handleFilterFieldChange(event));
        
        let operator = operatorElement.value;
        if(!!field && !!!field.type) field.type = "string"
        if(field && field.type){
            if(field.type === "number"){
                let valueNumberElement = baseEl.appendChild(document.createElement("input"));
                valueNumberElement.disabled = !editable;
                valueNumberElement.type = "number";
                if (filter instanceof NotFilter)
                    valueNumberElement.value = filter.filters[0].value || "";
                else
                    valueNumberElement.value = filter.value || "";
            } else if(field.type === "datetime"){
                if(["=","!="].includes(operator)){
                    let valueDatetimeElement = baseEl.appendChild(createDateTimeEl({time: false, timezone: false}));
                    if (filter instanceof NotFilter){
                        valueDatetimeElement.children[0].value = `${new Intl.DateTimeFormat(window.navigator.language, { dateStyle: "short", timeZone: guessTimezone()}).format(getDateTimestamp(Number(filter.filters[0].value) + this.#timeDifference))}`
                    }
                    else{
                        valueDatetimeElement.children[0].value = `${new Intl.DateTimeFormat(window.navigator.language, { dateStyle: "short", timeZone: guessTimezone()}).format(getDateTimestamp(Number(filter.value) + this.#timeDifference))}`
                    }
                }
                else if (["=*", "!=*"].includes(operator)){
                    let _div = baseEl.appendChild(document.createElement("div"));
                    _div.setAttribute("style", "grid-template-columns: 1fr 1fr; display: grid;");
                    let valueDatetimeElement = _div.appendChild(createDateTimeEl({time: true, timezone: false}, editable));
                    let valueDatetimeElement2 = _div.appendChild(createDateTimeEl({time: true, timezone: false}, editable));
                    if (filter instanceof NotFilter){
                        let values = filter?.filters[0]?.value?.split(":");
                        //`${new Intl.DateTimeFormat(window.navigator.language, { dateStyle: "short", timeStyle: "short", timeZone: "Etc/GMT" }).format(result.timestamp)}`
                        valueDatetimeElement.children[0].value = `${new Intl.DateTimeFormat(window.navigator.language, { dateStyle: "short", timeStyle: "short", timeZone: guessTimezone()}).format((new Date(Number(values[0]) + this.#timeDifference).getTime() || Date.now()))}`
                        valueDatetimeElement2.children[0].value = `${new Intl.DateTimeFormat(window.navigator.language, { dateStyle: "short", timeStyle: "short", timeZone: guessTimezone()}).format((new Date(Number(values[1]) + this.#timeDifference).getTime() || Date.now()))}`
                    }
                    else{
                        let values = filter?.value?.split(":");
                        valueDatetimeElement.children[0].value = `${new Intl.DateTimeFormat(window.navigator.language, { dateStyle: "short", timeStyle: "short", timeZone: guessTimezone()}).format((new Date(Number(values[0]) + this.#timeDifference).getTime() || Date.now()))}`
                        valueDatetimeElement2.children[0].value = `${new Intl.DateTimeFormat(window.navigator.language, { dateStyle: "short", timeStyle: "short", timeZone: guessTimezone()}).format((new Date(Number(values[1]) + this.#timeDifference).getTime() || Date.now()))}`
                    }
                        
                    
                }
                else {
                    let valueDatetimeElement = baseEl.appendChild(createDateTimeEl({time: true, timezone: false}, editable));
                    if (filter instanceof NotFilter){
                        valueDatetimeElement.children[0].value = `${new Intl.DateTimeFormat(window.navigator.language, { dateStyle: "short", timeStyle: "short", timeZone: guessTimezone()}).format((new Date(Number(filter.filters[0].value) + this.#timeDifference).getTime() || Date.now()))}`
                    }
                    else{
                        valueDatetimeElement.children[0].value = `${new Intl.DateTimeFormat(window.navigator.language, { dateStyle: "short", timeStyle: "short", timeZone: guessTimezone()}).format((new Date(Number(filter.value) + this.#timeDifference).getTime() || Date.now()))}`
                    }
                }   
                /*
                */
            } else {
                if (["!~=", "~="].includes(operator)){
                    let valueDivElement = baseEl.appendChild(document.createElement("div"));
                    valueDivElement.setAttribute("data-type", "in-list");
                    const valueEl = valueDivElement.appendChild(document.createElement("input"));
                    valueEl.type = "hidden";
                    if (filter instanceof NotFilter) {
                        valueEl.value = filter.filters[0].value || "";
                    } else {
                        valueEl.value = filter.value || "";
                    }
                    for(const tag of valueEl.value.split("||").filter(a => a.trim() !== "")){
                        const el = valueDivElement.appendChild(document.createElement("button"));
                        el.setAttribute("data-eb-tag", tag);
                        el.innerHTML = `<span aria-hidden="true">${tag}</span><svg class="toggle" data-src="/assets/images/remove.svg" aria-hidden="true"></svg>`;
                        el.addEventListener("click", (ev) => {
                            valueEl.value = valueEl.value.split("||").filter(a => a != tag).join("||");
                            ev.target.remove();
                        });
                    }
                    const inputEl = valueDivElement.appendChild(document.createElement("input"));
                    inputEl.type = "text";
                    inputEl.disabled = !editable;
                    inputEl.addEventListener("keydown", event => {
                        if(event.key === "Enter" && event.target.value.trim() !== ""){
                            const tags = event.target.value.trim().split("||").map(a => a.trim());
                            const oldTags = valueDivElement.firstChild.value.split("||");
                            const newTags = tags.filter(tag => !oldTags.includes(tag));
                            valueDivElement.firstChild.value = [...oldTags, ...newTags].filter(a => a.trim() !== "").join("||");
                            for (const tag of newTags) {
                                const el = valueDivElement.insertBefore(document.createElement("button"), inputEl);
                                el.setAttribute("data-eb-tag", tag);
                                el.innerHTML = `<span aria-hidden="true">${tag}</span><svg class="toggle" data-src="/assets/images/remove.svg" aria-hidden="true"></svg>`;
                                el.addEventListener("click", (ev) => {
                                    valueDivElement.firstChild.value = valueDivElement.firstChild.value.split("||").filter(a => a != tag).join("||");
                                    ev.target.remove();
                                });
                            }
                            event.target.value = "";
                        }
                    });

                } else {
                    if ((field?.options?.length || 0) > 0) {
                        let valueDropdownElement = baseEl.appendChild(document.createElement("select"));
                        valueDropdownElement.disabled = !editable;
                        for (let option of [ { displayText: "(Blank)", value: "" }, ...field.options ]) {
                            let valueOptionElement = valueDropdownElement.appendChild(document.createElement("option"));
                            valueOptionElement.value = option.value;
                            valueOptionElement.innerText = option.displayText || option.name || option.value;
                            if (filter instanceof NotFilter) {
                                if (filter.filters[0].value == option.value) {
                                    valueOptionElement.selected = true;
                                }
                            } else {
                                if (filter.value == option.value) {
                                    valueOptionElement.selected = true;
                                }
                            }
                        }
                    } else {
                        let valueElement = baseEl.appendChild(document.createElement("input"));
                        valueElement.disabled = !editable;
                        if (filter instanceof NotFilter)
                            valueElement.value = filter.filters[0].value || "";
                        else
                            valueElement.value = filter.value || "";
                    }
                }
            }
        }

        if(editable){
            let removeFilterButtonElement = baseEl.appendChild(document.createElement("button"));
            removeFilterButtonElement.innerHTML = `<svg data-src="/assets/images/trash.svg"></svg>`;
            removeFilterButtonElement.addEventListener("click", event => {
                if (event.target.closest("eb-filter-list").children.length == 1)
                    event.target.closest("eb-filter").remove();
                else
                    event.target.closest("eb-filter-list-item").remove();
            });
        }
    }

    buildView(filter, target = this.#filterElement, editable = true) {
        if ((filter instanceof AndFilter || filter instanceof OrFilter)) {
            let isCustom = this.checkCustomFromFilter(filter);
            if(isCustom){
                this.buildView(isCustom, target, editable);
            } else {
                this.buildEBFilter(filter, target, editable);
            }
        } else {
            this.buildEBFilterItem(filter, target, editable);
        }
        this.setIndicatorStyle(this.#filterElement, 0, editable);
    }


    setIndicatorStyle(baseElement = this.#filterElement, index = 0, editable = true) {
        const colors = editable ? ["lg-border", "lb-border", "lo-border"] : ["base-border", "base-border", "base-border"];
        const filters = []
        if(index > 2) index = 0;
        for (const child of baseElement.children){
            if(child.tagName === "EB-FILTER") filters.push(child);
            if(child.tagName === "EB-FILTER-LIST"){
                for (const child2 of child.children){
                    if(child2.tagName === "EB-FILTER") filters.push(child2);
                }
            }
        }
        for(var filter of filters){
            filter.classList.remove(["lg-border", "lb-border", "lo-border"]);
            filter.classList.add(colors[index]);
            index++;
            this.setIndicatorStyle(filter, index);
            if(index > 2) index = 0;
        }
    }

    buildFilter(target) {
        if (target?.tagName == "EB-FILTER") {
            if (target.children[1].children.length == 0)
                throw new Error("Invalid schema");
            return `(${target.children[0].children[0].value}${[...target.children[1].children].map(child => this.buildFilter(child)).join("")})`;
        } else if (target?.tagName == "EB-FILTER-LIST-ITEM") {
            const attr = target.children[0].value
            const field = this.#fields.find(a => a.name == attr)
            let retVal;
            const isCustom = this.checkCustomFromValues(attr, this.getListItemValue(field, target.children[2]), target.children[1].value);
            if(!!isCustom){
                retVal = isCustom;
            } else {
                if (target.children[1].value == "=" || target.children[1].value == "!="){
                    retVal = new EqualityFilter(target.children[0].value, this.getListItemValue(field, target.children[2]));
                }
                else if (target.children[1].value == ">=" || target.children[1].value == "!>="){
                    retVal = new GreaterThanEqualsFilter(target.children[0].value, this.getListItemValue(field, target.children[2]));
                }     
                else if (target.children[1].value == "<=" || target.children[1].value == "!<="){
                    retVal = new LessThanEqualsFilter(target.children[0].value, this.getListItemValue(field, target.children[2]));
                }
                else if (target.children[1].value == "=*" || target.children[1].value == "!=*"){
                    retVal = new SubstringFilter(target.children[0].value, `*${this.getListItemValue(field, target.children[2]).replace(/^\*/,"").replace(/\*$/,"")}*`);
                }
                else if (target.children[1].value == "^="){
                    retVal = new StartsWithFilter(target.children[0].value, `${this.getListItemValue(field, target.children[2])}`);
                }
                else if (target.children[1].value == "$="){
                    retVal = new EndsWithFilter(target.children[0].value, `${this.getListItemValue(field, target.children[2])}`);
                }
                else if (target.children[1].value == "~=" || target.children[1].value == "!~="){
                    retVal = new InListFilter(target.children[0].value, `${this.getListItemValue(field, target.children[2].children[0])}`);
                }
                else
                    throw new Error("Unknown filter");
                if (target.children[1].value.substring(0,1) == "!")
                    retVal = new NotFilter(retVal);
            }
            return retVal.toString();
        } else {
            return "";
            for (let child of target.children)
                return this.buildFilter(child);
        }
    }

    getNewPropertyFilter(sibling) {
        const siblingAttribute = sibling.children[0].value;
        const siblingType = sibling.children[1].value;
        let newFilter;
        if(["=", "!="].includes(siblingType)) newFilter = new EqualityFilter(siblingAttribute, "");
        if([">=", "!>="].includes(siblingType)) newFilter = new GreaterThanEqualsFilter(siblingAttribute, "");
        if(["<=", "!<="].includes(siblingType)) newFilter = new LessThanEqualsFilter(siblingAttribute, "");
        if(["=*", "!=*"].includes(siblingType)) newFilter = new SubstringFilter(siblingAttribute, "");
        if(["^="].includes(siblingType)) newFilter = new StartsWithFilter(siblingAttribute, "");
        if(["$="].includes(siblingType)) newFilter = new EndsWithFilter(siblingAttribute, "");
        if(["~="].includes(siblingType)) newFilter = new InListFilter(siblingAttribute, "");
        if (siblingType.substring(0,1) == "!") newFilter = new NotFilter(newFilter);
        return newFilter;
    }

    getListItemValue(field, element){
        let retVal = null;
        if(!!!field.type) field.type = "string";
        if(element.tagName === "DIV" && element.children.length > 0){
            retVal = [];
            for(const child of element.children){
                if(["INPUT", "SELECT", "DIV"].includes(child.tagName)){
                    retVal.push(this.getListItemValue(field, child));
                }
            }
            if(retVal.length === 1) retVal = retVal[0];
            return retVal;
        }
        if(field.type === "number"){
            retVal =  (Number(element.value) || 0).toString();
        } else if (field.type === "datetime"){
            const comparator = element.parentElement.parentElement.children[1].value;
            if(["=", "!="].includes(comparator)){
                retVal = getDateTimestamp(element.value);
                //retVal = retVal - this.#timeDifference;
            } else {
                retVal =  (new Date(element.value).getTime() /*- this.#timeDifference*/).toString();
            }
        } else {
            retVal = element.value;
        }
        return retVal;
    }

    checkCustomFromFilter(filters){
        if(filters.filters.length != 2) return null;
        let isDateTime = true;
        let isNot = false;
        let attributes = [];
        let values = [];
        for(var _filter of filters.filters){
            let filter = _filter;
            if(filter instanceof NotFilter){
                isNot = true;
                filter = filter.filters[0];
            }
            if(!!filter?.filters) return null;
            const field = this.getField(filter.attribute);
            if(!!isDateTime){
                isDateTime = field?.type === "datetime";
            }
            attributes.push(filter.attribute);
            values.push(filter.value);
        }
        if(((values[0].toString().slice(-5) !== "00000" || values[1].toString().slice(-5) !== "00000")) && (attributes[0] === attributes[1]) && isDateTime && `(&(${isNot ? "!(" : ""}${attributes[0]}>=${values[0]})${isNot ? ")" : ""}(${isNot ? "!(" : ""}${attributes[0]}<=${values[1]}${isNot ? ")" : ""}))` == filters.toString()){
            let ret;
            if(isNot){
                ret = new NotFilter(new SubstringFilter(attributes[0], `${values[0]}:${values[1]}`));
            } else {
                ret = new SubstringFilter(attributes[0], `${values[0]}:${values[1]}`);
            }
            
            return ret;
        }
        //values[0].toString().slice(-5) === "00000"
        else if((values[0].toString().slice(-5) === "00000" && values[1].toString().slice(-5) === "00000") && isDateTime && `(&(${isNot ? "!(" : ""}${attributes[0]}>=${values[0]})${isNot ? ")" : ""}(${isNot ? "!(" : ""}${attributes[0]}<=${values[1]}${isNot ? ")" : ""}))` == filters.toString()){
            let ret=new AndFilter();
            if(isNot){
                ret = new NotFilter(new EqualityFilter(attributes[0], `${values[0]}`));
            } else {
                if(attributes[0]==attributes[1]){
                    if(filters.filters[1] instanceof LessThanEqualsFilter && filters.filters[0] instanceof GreaterThanEqualsFilter){
                        ret.addFilter(new LessThanEqualsFilter(attributes[0], `${values[1]}`));
                        ret.addFilter(new GreaterThanEqualsFilter(attributes[0], `${values[0]}`));
                    }
                   else{
                    ret = new EqualityFilter(attributes[0], `${values[0]}`);
                   }
                }
                else{
                    ret = new EqualityFilter(attributes[0], `${values[0]}`);
                }
            }
            
            return ret;
        }
        return null;
    }

    checkCustomFromValues(attribute, value, comparator){
        const isDatetime = this.getField(attribute)?.type === "datetime";
        if(isDatetime && ["=*", "!=*"].includes(comparator) && value.length === 2){
            let ret = new AndFilter();
            if(comparator.substring(0,1) === "!"){
                ret.addFilter(new NotFilter(new GreaterThanEqualsFilter(attribute, value[0])));
                ret.addFilter(new NotFilter(new LessThanEqualsFilter(attribute, value[1])));
            } else {
                ret.addFilter(new GreaterThanEqualsFilter(attribute, value[0]));
                ret.addFilter(new LessThanEqualsFilter(attribute, value[1]));
            }
            return ret;
        } 
        else if(isDatetime && ["=", "!="].includes(comparator) && !Array.isArray(value)){
            let ret = new AndFilter();
            if(comparator.substring(0,1) === "!"){
                ret.addFilter(new NotFilter(new GreaterThanEqualsFilter(attribute, value.toString())));
                ret.addFilter(new NotFilter(new LessThanEqualsFilter(attribute, (value + 86400000).toString())));
            } else {
                ret.addFilter(new GreaterThanEqualsFilter(attribute, value.toString()));
                ret.addFilter(new LessThanEqualsFilter(attribute, (value + 86400000).toString()));
            }
            return ret;
        }
    }

    getField(attribute){
        return this.#fields.find(a => a.name == attribute);
    }

    getComparator(filter, isNot = false){
        if(filter instanceof NotFilter){
            return this.getComparator(filter, true);
        }
        if(filter instanceof EqualityFilter){
            return `${isNot ? "!" : ""}=`
        }
        if(filter instanceof GreaterThanEqualsFilter){
            return `${isNot ? "!" : ""}>=`
        }
        if(filter instanceof LessThanEqualsFilter){
            return `${isNot ? "!" : ""}<=`
        }
        if(filter instanceof SubstringFilter){
            return `${isNot ? "!" : ""}=*`
        }
        if(filter instanceof StartsWithFilter){
            return `^=`;
        }
        if(filter instanceof EndsWithFilter){
            return `$=`
        }
        if(filter instanceof InListFilter){
            return `${isNot ? "!" : ""}~=`
        }
    }

}

function createDateTimeEl(opts = {time: true, timezone: false}, editable = true){
    let container = document.createElement("div");
    container.className = "input-group";
    container.innerHTML = `
        <input type="text" disabled readonly>
        <button title="pick date/time" aria-label="pick date/time">
            <svg data-src="/assets/images/datetimepicker.svg"></svg></button>
    `
    let input = container.querySelector("input");
    input.disabled = !editable;
    let button = container.querySelector("button");
    button.disabled = !editable;
    if(editable){
        button.addEventListener("click", async (event) => {
            await showDateTimePicker(input, opts);
        })
    }
    return container;
}

async function showDateTimePicker(el, opts) {
    const modal = new DateTimeTimezonePickerModal(new Date(el.value), "Etc/GMT", opts);
    const result = await modal.open();
    if (!!!result) return;
    const opts2 = {
        dateStyle: "short"
    }
    if(opts.time) opts2["timeStyle"] = "short";


    let timestamp = result.timestamp;
    if(!!!opts.time){
        timestamp = getDateTimestamp(timestamp);
    }
    
    el.value = `${new Intl.DateTimeFormat(window.navigator.language, opts2).format(timestamp)}`;
}

function getDateTimestamp(timestamp){
    if(!!!timestamp) timestamp = Date.now();
    let ret = timestamp;
    if(typeof timestamp === 'string'){
        try{
            ret = Number(timestamp);
            if(isNaN(ret)) throw new Error("Not a number");
        }
        catch(ex){
            ret = new Date(timestamp).getTime();
        }
    }
    return new Date(new Date(ret).toDateString()).getTime();
}

function getTimeDifference(){
    const atTime = new Date(Date.now());
    const localTime = new Date(atTime.toLocaleString("en-US"));
    const remoteTime = new Date(atTime.toLocaleString("en-US", {timeZone: "Etc/GMT"}));
    const adjustBy = Math.round((remoteTime.getTime() - localTime.getTime()));
    return adjustBy;
}